import { Injectable } from "@angular/core";
import { localize } from "@gtmhub/localization";
import { UiModalService } from "@webapp/ui/modal/services/modal.service";
import { ConfirmBadgeDeleteComponent, ConfirmBadgeDeleteModalData } from "../components/confirm-badge-delete/confirm-badge-delete.component";
import { BadgeAssignment } from "../models/badges.models";

type ConfirmBadgeDeleteArgs = {
  badgeAssignments: BadgeAssignment[];
  action(): void | Promise<void>;
};

type ConfirmBadgeApproveOrRejectArgs = {
  action(): void | Promise<void>;
};

@Injectable()
export class ConfirmBadgeActionService {
  constructor(private modalService: UiModalService) {}

  public confirmDelete(args: ConfirmBadgeDeleteArgs): void {
    this.modalService.confirm<ConfirmBadgeDeleteComponent, ConfirmBadgeDeleteModalData>({
      uiTitle: localize("delete_badge"),
      uiContent: ConfirmBadgeDeleteComponent,
      uiData: args,
      uiIconType: null,
      uiOkText: localize("delete"),
      uiOkDanger: true,
      uiOnOk: () => args.action(),
      uiCancelText: localize("cancel"),
    });
  }

  public confirmReject(args: ConfirmBadgeApproveOrRejectArgs): void {
    this.modalService.confirm({
      uiTitle: localize("reject_badge_confirmation"),
      uiContent: localize("this_cant_be_undone"),
      uiOkText: localize("reject"),
      uiOnOk: () => args.action(),
      uiCancelText: localize("cancel"),
    });
  }

  public confirmApprove(args: ConfirmBadgeApproveOrRejectArgs): void {
    this.modalService.confirm({
      uiTitle: localize("approve_badge_confirmation"),
      uiContent: localize("this_cant_be_undone"),
      uiOkText: localize("approve"),
      uiOnOk: () => args.action(),
      uiCancelText: localize("cancel"),
    });
  }

  public confirmUnassign(args: ConfirmBadgeApproveOrRejectArgs): void {
    this.modalService.confirm({
      uiTitle: localize("unassign_badge_confirmation"),
      uiContent: "",
      uiIconType: null,
      uiOkText: localize("unassign"),
      uiOnOk: () => args.action(),
      uiOkDanger: true,
      uiCancelText: localize("cancel"),
    });
  }
}
